import Vue from 'vue'
Vue.config.devtools = process.env.VUE_APP_ENABLE_VUE_DEV_TOOLS === 'true' || false
Vue.config.productionTip = false
